import React, { useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, SendIcon } from 'lucide-react';
interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ContactModal({
  isOpen,
  onClose
}: ContactModalProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [offer, setOffer] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    const recipient = ['j1981rodriguez', 'yahoo.com'].join('@');
    const subject = encodeURIComponent('Domain Inquiry: totemrestobar.com');
    const body = encodeURIComponent(`Name: ${name}\nPhone: ${phone}\nOffer: ${offer || 'Not specified'}\n\nThis inquiry is regarding the domain totemrestobar.com.`);
    setTimeout(() => {
      window.location.href = `mailto:${recipient}?subject=${subject}&body=${body}`;
      setIsSubmitting(false);
      setIsSuccess(true);
      setTimeout(() => {
        setIsSuccess(false);
        setName('');
        setPhone('');
        setOffer('');
        onClose();
      }, 2500);
    }, 800);
  };
  return <AnimatePresence data-id="element-19">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-20">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} onClick={e => e.stopPropagation()} className="bg-zinc-900 border border-zinc-800 p-8 rounded-xl w-full max-w-md relative overflow-hidden shadow-2xl" data-id="element-21">
              <button onClick={onClose} className="absolute top-4 right-4 text-zinc-400 hover:text-white transition-colors" data-id="element-22">
                <XIcon size={20} data-id="element-23" />
              </button>

              <h3 className="text-2xl text-[#FFD700] mb-2 font-serif" data-id="element-24">
                Inquire About Domain
              </h3>
              <p className="text-zinc-400 text-sm mb-6" data-id="element-25">
                Interested in{' '}
                <span className="text-white font-medium" data-id="element-26">
                  totemrestobar.com
                </span>
                ? Fill in your details and we'll get back to you.
              </p>

              {isSuccess ? <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} className="py-12 flex flex-col items-center justify-center text-center" data-id="element-27">
                  <div className="w-12 h-12 rounded-full bg-green-500/20 text-green-400 flex items-center justify-center mb-4" data-id="element-28">
                    <SendIcon size={24} data-id="element-29" />
                  </div>
                  <p className="text-lg text-white" data-id="element-30">
                    Inquiry Sent Successfully
                  </p>
                  <p className="text-zinc-400 text-sm mt-2" data-id="element-31">
                    We'll review your offer and be in touch soon.
                  </p>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-32">
                  <div data-id="element-33">
                    <label htmlFor="name" className="block text-xs font-medium text-zinc-400 mb-1 uppercase tracking-wider" data-id="element-34">
                      Full Name
                    </label>
                    <input type="text" id="name" required value={name} onChange={e => setName(e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#FFD700] focus:ring-1 focus:ring-[#FFD700] transition-all" placeholder="John Doe" data-id="element-35" />
                  </div>
                  <div data-id="element-36">
                    <label htmlFor="phone" className="block text-xs font-medium text-zinc-400 mb-1 uppercase tracking-wider" data-id="element-37">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" required value={phone} onChange={e => setPhone(e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#FFD700] focus:ring-1 focus:ring-[#FFD700] transition-all" placeholder="(555) 123-4567" data-id="element-38" />
                  </div>
                  <div data-id="element-39">
                    <label htmlFor="offer" className="block text-xs font-medium text-zinc-400 mb-1 uppercase tracking-wider" data-id="element-40">
                      Your Offer
                    </label>
                    <input type="text" id="offer" required value={offer} onChange={e => setOffer(e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#FFD700] focus:ring-1 focus:ring-[#FFD700] transition-all" placeholder="$ USD" data-id="element-41" />
                  </div>

                  <button type="submit" disabled={isSubmitting} className="w-full bg-[#FFD700] hover:bg-[#F0C800] text-black font-semibold py-3 rounded-lg mt-6 transition-all disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-42">
                    {isSubmitting ? <div className="w-5 h-5 border-2 border-black/30 border-t-black rounded-full animate-spin" data-id="element-43" /> : 'Submit Inquiry'}
                  </button>
                </form>}
            </motion.div>
          </motion.div>
        </>}
    </AnimatePresence>;
}